import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=38bafbfa&scoped=true"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=38bafbfa&prod&lang=css"
import style1 from "./ResetPwd.vue?vue&type=style&index=1&id=38bafbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bafbfa",
  null
  
)

export default component.exports